<template>
  <main>
    <div class="page" v-if="post">
      <header class="page-header">
        <p>{{ post.categories.nodes[0].name }}</p>
      </header>
      <div class="page-content">
        <article class="post">
          <div class="post-header">
            <p class="post-date">{{ getFormatDate(post.date) }}</p>
            <h1 class="post-title">{{ post.title }}</h1>
          </div>
          <div class="post-content template" v-html="post.content"></div>
        </article>
      </div>
    </div>
  </main>
</template>

<script>
import getPostByPostIdGql from '../apollo/queries/getPostByPostId.gql'

export default {
  name: 'PostDetail',
  data () {
    return {
      post: null,
    }
  },
  methods: {

  },
  apollo: {
    post: {
      query: getPostByPostIdGql,
      variables () {
        return {
          postId: this.$route.params.postId,
        }
      },
    },
  }
}
</script>

<style lang="stylus" scoped>


</style>
